import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Programs.css";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";

const Events = () => {
  const baseUrl =
    "https://isbmuniversity.edu.in/admin-portal/admin-assets/event-banners/";

  const [events, setEvents] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/eventApi"
        );
        setEvents(response.data.data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  const events_slider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  };

  return (
    <section className="ptb-50">
      <div className="container-xxl">
        <Row className="m-0">
          <Col md={6}>
            <div className="top-recruiters">
              <h2 className="modern-title">
                Inspiring Minds Through <span>Memorable Moments</span>
              </h2>
              <p>
                ISBM University brings global exposure to its students through
                dynamic international events. Explore learning beyond borders.
              </p>
              <p>
                These events are an integral part of the University’s effort to
                build a globally aware academic community.
              </p>
            </div>
          </Col>
          <Col md={6}>
            <Slider {...events_slider} className="blogSwiper">
              {events.map((event) => (
                <div className="about-card shadow rounded p-3 h-100 d-flex flex-column">
                  <div className="content-pad">
                    <div className="post-item row">
                      <div className="col-md-6 col-sm-12">
                        <div className="content-pad">
                          <div className="item-thumbnail">
                            <Link
                              to={`/event-details/${event.id}`}
                              target="_blank"
                              title={event.title}
                            >
                              <img
                                src={baseUrl + event.banner}
                                width="100%"
                                alt={event.title}
                                style={{ height: "250px", objectFit: "cover" }}
                              />
                              <span className="thumbnail-overlay">
                                Date: {event.schedule || "Event"}
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="content-pad">
                          <div className="item-content">
                            {/* <h3 className="item-title about-main-header">
                              Events
                            </h3> */}
                            <Link
                              to={`/event-details/${event.id}`}
                              className="main-color-1-hover about_usisbm"
                            >
                              {event.title}
                            </Link>
                            <div className="item-meta">
                              <Link
                                to={`/event-details/${event.id}`}
                                target="_blank"
                                className="btn-lighter"
                              >
                                Read More <i className="ti ti-arrow-right"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* /post-item */}
                  </div>
                </div>
              ))}
            </Slider>
            {/* Custom Navigation Arrows */}
            {/* <div className="custom-swiper-nav justify-content-start mt-3 d-flex">
              <button ref={prevRef} className="custom-arrow">
                &#8592;
              </button>
              <button ref={nextRef} className="custom-arrow">
                &#8594;
              </button>
            </div> */}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Events;
